// extracted by mini-css-extract-plugin
export default {"root":"SignupVerify__root--F-nUHF","center":"SignupVerify__center--0kBqQ-","loader":"SignupVerify__loader--2fR1MN"};